import { IllustrationProps } from 'fe-design-base/assets/types';
import Box from 'fe-design-base/atoms/Box';

import bubble_airplane from './imageFiles/bubble_airplane.png';
const BubbleAirplane = (props: IllustrationProps) => (
  <Box
    w={72}
    {...props}
    minw={72}
    className={`FDBIllustration${
      props?.className ? ` ${props.className}` : ''
    }`}
  >
    <img
      src={bubble_airplane}
      style={{ width: '100%' }}
      alt="Bubble Airplane Illustration"
    />
  </Box>
);
export default BubbleAirplane;
